import { useEffect } from 'react';

import Loading, { LoadingScale } from 'bloko/blocks/loading';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import Filter, { DEFAULT_FILTER_DATES } from 'components/Admin/InvoiceDetail/Filter';
import fetchPayments from 'components/Admin/InvoiceDetail/Payments/fetchPayments';
import Header from 'components/Admin/InvoiceDetail/Payments/Header';
import Payment from 'components/Admin/InvoiceDetail/Payments/Payment';
import TitleWithInvoiceNumber from 'components/Admin/InvoiceDetail/TitleWithInvoiceNumber';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/InvoiceDetail/Payments/Payments.less';

const Payments = () => {
    const { invoiceId, invoice, payments, isLoadPayments, refunds } = useSelector((state) => state.invoiceDetail);

    const dispatch = useDispatch();

    const trl = useTrls();

    useEffect(() => {
        const dates = DEFAULT_FILTER_DATES(invoice);
        dispatch(fetchPayments(invoiceId, dates.from, dates.to));
    }, [dispatch, invoice, invoiceId]);
    return (
        <div className="invoice-payments">
            <TitleWithInvoiceNumber titleBlock={trl('admin.Invoices.InvoicesDetail.Invoice.Payments')} {...invoice} />
            <Filter invoiceId={invoiceId} fetchItems={fetchPayments} />
            {isLoadPayments && <Loading scale={LoadingScale.Medium} />}
            {!isLoadPayments && payments.length === 0 && (
                <div>{trl('admin.Invoices.InvoicesDetail.Invoice.Payments.empty')}</div>
            )}
            {!isLoadPayments && payments.length > 0 && (
                <Table bordered fullWidth withStripes>
                    <TableHead>
                        <Header />
                    </TableHead>
                    <TableBody>
                        {payments.map((payment) => {
                            const paymentRefunds = refunds.filter(({ paymentId }) => paymentId === payment.id);
                            return <Payment key={payment.id} {...payment} refunds={paymentRefunds} />;
                        })}
                    </TableBody>
                </Table>
            )}
        </div>
    );
};

export default Payments;
